import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        id
        email
        role
        agencyName
        agency {
          name
          logo
        }
      }
      token
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation Register(
    $email: String!, 
    $password: String!, 
    $role: String!, 
    $agencyName: String!,
    $subdomain: String!,
    $domainType: String!
  ) {
    register(
      email: $email, 
      password: $password, 
      role: $role, 
      agencyName: $agencyName,
      subdomain: $subdomain,
      domainType: $domainType
    ) {
      user {
        id
        email
        role
        agencyName
        agency {
          name
          logo
          subdomain
          domainType
        }
      }
      token
    }
  }
`; 

/* FORGOT PASSWORD */
export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword(
    $email: String!
    $code: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    resetPassword(
      email: $email,
      code: $code,
      newPassword: $newPassword,
      confirmPassword: $confirmPassword
    ) {
      success
      message
    }
  }
`;
